<template>
  <article class="panel is-warning">
    <p class="panel-heading">
      Gebroken links
    </p>

    <div class="panel-block has-background-white-ter">
      <p>Onderstaande teksten komen niet meer voor in de pagina en zijn niet meer zichtbaar voor gebruikers die zonder beheerrechten de pagina bezoeken.<br>De kolomwaarde waaraan dit item gekoppeld is, is gewijzigd, verwijderd, of leeg gemaakt. Verwijder het item definitief of plaats het op een andere plek in de pagina om het weer zichtbaar te maken. Het kan hier ook blijven staan voor later gebruik.</p>
    </div>

    <div class="panel-block has-background-white-ter">
      <p>Het terugplaatsen kun je alsvolgt doen. Open het pad waar de tekst naartoe moet in de boom of het grid. Als
        de tekstverwerker geopend is klik je op de tekst die je op deze plek wilt hebben. Indien er al tekst staat
        wordt de tekst uit deze lijst onder de bestaande tekst geplaatst en gemarkeerd. Klik op Opslaan om de
        terugplaatsing definitief te maken.</p>
    </div>

    <a
      v-for="(orphan, idx) in page.orphans"
      :key="idx"
      class="list-group-item panel-block draggable-element"
      :class="{ 'has-background-success': isRemovable(orphan.id) }"
      @click="(!isRemovable(orphan.id)) ? restore(orphan) : null">

      <button
        class="delete is-pulled-right"
        title="Definitief verwijderen"
        @click="remove(orphan.id)">
      </button>

      &nbsp;&nbsp;&nbsp;{{ clean(orphan.text).substr(0, 100) }}
    </a>
  </article>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageOrphans',
  props: {
    path: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      putBack: false
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page',
      item: 'pageItems/item',
      removables: 'pageItems/removables'
    }),
    identifier () {
      return this.path.slice(0, this.path.length).join(':')
    }
  },
  methods: {
    restore (payload) {
      if (this.item.id) {
        this.$store.commit('pageItems/SET_ITEM_TEXT', this.replace(payload))
      } else {
        const item = JSON.parse(JSON.stringify(payload))

        item.id = null
        item.path = this.identifier

        this.$store.commit('pageItems/SET_ITEM', item)
      }

      this.$store.commit('pageItems/SET_REMOVABLE', payload.id)
    },
    remove (id) {
      this.$store.dispatch('pageItems/remove', [id])
    },
    clean (html) {
      let temporalDivElement = document.createElement('div')
      temporalDivElement.innerHTML = html

      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    replace (payload) {
      const timestamp = new Date()

      return `${this.item.text}<br>
        ========= vvv TERUGGEPLAATST OP ${timestamp} vvv =========<br>
        ${payload.text}<br>
        ========= ^^^ TERUGGEPLAATST OP ${timestamp} ^^^ =========`
    },
    isRemovable (id) {
      return this.removables.includes(id)
    }
  }
}
</script>

<style scoped>

</style>
